import { useEffect, useState } from "react";
import { WhatsAppIcon } from "./icons";
import { scrollToId } from "../lib/scroll";
import { SITE, waLink } from "../lib/site";

export function FloatingActions() {
  const [showBar, setShowBar] = useState(false);
  const [formNear, setFormNear] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowBar(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    const formEl = document.getElementById("customise");
    let io: IntersectionObserver | null = null;
    if (formEl) {
      io = new IntersectionObserver((entries) => setFormNear(entries[0].isIntersecting), {
        rootMargin: "-10% 0px -10% 0px",
      });
      io.observe(formEl);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      io?.disconnect();
    };
  }, []);

  return (
    <>
      <a
        href={waLink(SITE.waGenericMessage)}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Enquire on WhatsApp"
        data-testid="floating-whatsapp-button"
        className="fixed right-4 z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-forest text-ivory shadow-tuft-lg transition-transform duration-200 hover:scale-105"
        style={{ bottom: showBar ? "5.5rem" : "1.25rem" }}
      >
        <span
          aria-hidden="true"
          className="absolute inset-0 rounded-full border-2 border-brass animate-pulse-ring"
        />
        <WhatsAppIcon className="h-6 w-6" />
      </a>

      <div
        className={`sm:hidden fixed inset-x-0 bottom-0 z-40 transition-transform duration-300 ease-out ${
          showBar && !formNear ? "translate-y-0" : "translate-y-full"
        }`}
        data-testid="mobile-sticky-cta"
      >
        <div className="m-3">
          <button
            onClick={() => scrollToId("customise")}
            data-testid="mobile-create-rug-button"
            className="w-full rounded-full bg-forest text-ivory font-medium py-3.5 shadow-tuft-lg transition-colors duration-200 hover:bg-forest-deep"
          >
            Create Your Rug
          </button>
        </div>
      </div>
    </>
  );
}
